import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ContactDetailsController from 'donor-elf-web/controllers/funds/fund/contacts/contact/details';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export default class ContactDetailsRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;

  model() {
    let contact = this.modelFor('funds.fund.contacts.contact').contact;
    if (this.navbarSettings.title !== contact.name) {
      this.navbarSettings.title = contact.name;
    }

    return {
      contact,
    };
  }

  setupController(controller: any, model: any, transition: any) {
    super.setupController(controller, model, transition);
    (controller as ContactDetailsController).setup();
  }
}
